import { UploadImageNativeFileNames, UploadImagesFormFields } from '../types';

export const getNativeFileName = (fieldName: string) => {
    switch (fieldName) {
        case UploadImagesFormFields.androidAppLogoHDPIPortrait:
            return UploadImageNativeFileNames.androidAppLogoHDPIPortrait;
        case UploadImagesFormFields.androidAppLogoXHDPIPortrait:
            return UploadImageNativeFileNames.androidAppLogoXHDPIPortrait;
        case UploadImagesFormFields.androidAppIconHDPIPortrait:
            return UploadImageNativeFileNames.androidAppIconHDPIPortrait;
        case UploadImagesFormFields.androidAppIconXHDPIPortrait:
            return UploadImageNativeFileNames.androidAppIconXHDPIPortrait;
        case UploadImagesFormFields.androidAppIconXXHDPIPortrait:
            return UploadImageNativeFileNames.androidAppIconXXHDPIPortrait;
        case UploadImagesFormFields.androidSplashScreenHDPIPortrait:
            return UploadImageNativeFileNames.androidSplashScreenHDPIPortrait;
        case UploadImagesFormFields.androidSplashScreenXHDPIPortrait:
            return UploadImageNativeFileNames.androidSplashScreenXHDPIPortrait;
        case UploadImagesFormFields.androidSplashScreenXXHDPIPortrait:
            return UploadImageNativeFileNames.androidSplashScreenXXHDPIPortrait;
        // case UploadImagesFormFields.iosAppIconipad:
        //     return UploadImageNativeFileNames.iosAppIconipad;
        // case UploadImagesFormFields.iosAppIconiphone:
        //     return UploadImageNativeFileNames.iosAppIconiphone;
        case UploadImagesFormFields.iosAppDefaultIcon:
            return UploadImageNativeFileNames.iosAppDefaultIcon;
        // case UploadImagesFormFields.iosSplashScreenipad:
        //     return UploadImageNativeFileNames.iosSplashScreenipad;
        case UploadImagesFormFields.iosSplashScreeniphone:
            return UploadImageNativeFileNames.iosSplashScreeniphone;
        case UploadImagesFormFields.iosAppApplicationLogo:
            return UploadImageNativeFileNames.iosAppApplicationLogo;
        default: return '';
    }
};

export const getMappedFormfieldName = (nativeFileName: string) => {
    switch (nativeFileName) {
        case UploadImageNativeFileNames.androidAppLogoHDPIPortrait:
            return UploadImagesFormFields.androidAppLogoHDPIPortrait;
        case UploadImageNativeFileNames.androidAppLogoXHDPIPortrait:
            return UploadImagesFormFields.androidAppLogoXHDPIPortrait;
        case UploadImageNativeFileNames.androidAppIconHDPIPortrait:
            return UploadImagesFormFields.androidAppIconHDPIPortrait;
        case UploadImageNativeFileNames.androidAppIconXHDPIPortrait:
            return UploadImagesFormFields.androidAppIconXHDPIPortrait;
        case UploadImageNativeFileNames.androidAppIconXXHDPIPortrait:
            return UploadImagesFormFields.androidAppIconXXHDPIPortrait;
        case UploadImageNativeFileNames.androidSplashScreenHDPIPortrait:
            return UploadImagesFormFields.androidSplashScreenHDPIPortrait;
        case UploadImageNativeFileNames.androidSplashScreenXHDPIPortrait:
            return UploadImagesFormFields.androidSplashScreenXHDPIPortrait;
        case UploadImageNativeFileNames.androidSplashScreenXXHDPIPortrait:
            return UploadImagesFormFields.androidSplashScreenXXHDPIPortrait;
        // case UploadImageNativeFileNames.iosAppIconipad:
        //     return UploadImagesFormFields.iosAppIconipad;
        // case UploadImageNativeFileNames.iosAppIconiphone:
        //     return UploadImagesFormFields.iosAppIconiphone;
        case UploadImageNativeFileNames.iosAppDefaultIcon:
            return UploadImagesFormFields.iosAppDefaultIcon;
        // case UploadImageNativeFileNames.iosSplashScreenipad:
        //     return UploadImagesFormFields.iosSplashScreenipad;
        case UploadImageNativeFileNames.iosSplashScreeniphone:
            return UploadImagesFormFields.iosSplashScreeniphone;
        case UploadImageNativeFileNames.iosAppApplicationLogo:
            return UploadImagesFormFields.iosAppApplicationLogo;
        default: return '';
    }
};
